<div class="df-dynamic-slide-toggle-wrapper">
  <mat-slide-toggle
    [formControl]="control"
    [attr.name]="name"
    [required]="required"
    color="primary"
  >
    {{ label }}
  </mat-slide-toggle>
  <span class="mat-hint df-dynamic-element-hint">{{ hint }}</span>
</div>
